import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";

type HandlerType = Handler<GetShipTosApiParameter>;

export const DispatchUpdateShipTosSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Pages/BudgetManagement/UpdateShipTosSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateShipTosSearchFields];

const updateShipTosSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateShipTosSearchFields");
export default updateShipTosSearchFields;
